import {
  Box,
  GreyGrey80,
  Primary13Regular,
  SimpleModal
} from '@sequencehq/core-components'
import { FC } from 'react'
import { useUnlinkHubSpotDealModal } from './useUnlinkHubSpotDealModal'

export const UnlinkHubSpotDealModal: FC<{
  dealId: string
  onUnlink: () => void
  onClose: () => void
}> = props => {
  const hook = useUnlinkHubSpotDealModal({
    dealId: props.dealId,
    onConfirm: props.onUnlink
  })

  return (
    <SimpleModal
      isOpen
      variant="dialog"
      onClose={props.onClose}
      data-testid="hubspot.deal.unlink.modal"
      title="Unlink this quote from HubSpot"
      isDestructive
      disableSubmitOnEnter
      submitButtonText="Unlink"
      submittingButtonText="Unlinking..."
      cancelButtonText="Cancel"
      submitDisabled={hook.submit.disabled}
      submitting={hook.submit.unlinking}
      onSubmit={hook.submit.onClick}
    >
      <Box color={GreyGrey80} {...Primary13Regular} flex={1}>
        This will unlink the quote from the HubSpot deal immediately. You can
        re-link the quote again if required.
      </Box>
    </SimpleModal>
  )
}
